/*
 * Спільна оправа екранів: панель, плитка, дрібний mono-текст. Тут немає піксельних
 * розмірів — усе через `styles/tokens.css`, бо саме розсипані по компонентах інлайнові
 * `font:` зробили попередню зміну щільності неможливою.
 */

.mono {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-variant-numeric: tabular-nums;
  color: var(--t4);
}

.dim {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  line-height: var(--lh-snug);
  color: var(--t8);
}

.panel {
  border: 1px solid var(--line2);
  border-radius: var(--r-lg);
  background: var(--card);
  padding: var(--pad-card);
}

.panelTitle {
  font-size: var(--fs-lg);
  font-weight: 600;
  line-height: var(--lh-snug);
  color: var(--t2);
}

.panelBody {
  margin-top: var(--sp-2);
  font-size: var(--fs-cell);
  line-height: var(--lh-base);
  color: var(--t7);
}

/* KPI-плитка дашборда. У мокапі їх п'ять і всі клікабельні — див. Етап 2. */
.tile {
  flex: 1 1 180px;
  min-width: 160px;
  border: 1px solid var(--line2);
  border-radius: var(--r-lg);
  background: var(--card);
  padding: var(--pad-card);
}

.tileLabel {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-micro);
  font-weight: 600;
  line-height: var(--lh-tight);
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  color: var(--t9);
}

.tileValue {
  margin-top: var(--sp-3);
  font-size: var(--fs-display);
  font-weight: 600;
  line-height: var(--lh-snug);
  font-variant-numeric: tabular-nums;
  color: var(--t0);
}

/* Критичне число має читатись як критичне, а не як просто число. */
.tileValueDanger {
  composes: tileValue;
  color: var(--r-txt);
}

.warn {
  color: var(--a-txt);
}

.danger {
  color: var(--r-txt);
}

/*
 * Діфф версій промпту. Моноширинний навмисно: рядки промпту читають як інструкції, і
 * вирівнювання лівого краю — єдине, що дає побачити зміщення відступу як зміну.
 */
.diffAdded,
.diffRemoved {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: var(--fs-small);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.diffAdded {
  color: var(--g-txt);
}

.diffRemoved {
  color: var(--r-txt);
}

/*
 * Панель масових дій — мокап, рядок 239: смуга акцентного відтінку, що зʼявляється рівно
 * тоді, коли є вибрані рядки, і несе кнопки операцій. Вона ж єдиний вхід на екран масових
 * операцій: у сайдбарі мокапа такого пункту немає.
 */
.bulkBar {
  padding: 9px 12px;
  background: var(--g08);
  border: 1px solid var(--g28);
  border-radius: var(--r-md);
  /* Кнопок п'ять, і на 768 вони мусять перенестись, а не виїхати за край. */
  flex-wrap: wrap;
}

.bulkBarLabel {
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  line-height: var(--lh-snug);
  font-weight: 600;
  color: var(--g-txt);
  white-space: nowrap;
}
